/**
 * Sticky
 *
 * Copyright (c) 2020 Aperia Company
 * Released under the MIT license
 */
"use strict";
import { WINDOW, CLASS_HEADER, CLASS_MAIN_CONTENT } from "@utils/constants";
import { isExists } from "@utils/validate";

/**
 * Sticky thisect
 */
const Sticky = function () {
  // const CLASS_HEADER = ".header";
  // const CLASS_HEADER_BOTTOM = ".header-bottom";
  const IS_STICKY = "sticky";
  // const getHeightHeader = $(CLASS_HEADER).innerHeight();
  // const getHeightHeaderBottom = $(CLASS_HEADER_BOTTOM).innerHeight();

  /**
   * addSticky function
   */
  this.addSticky = () => {
    $(CLASS_HEADER).addClass(IS_STICKY);
    // if (isMobile()) {
    //   $(CLASS_MAIN_CONTENT).css("margin-top", getHeightHeader);
    // } else {
    //   $(CLASS_MAIN_CONTENT).css("margin-top", "89px");
    // }
  };
  /**
   * removeSticky function
   */
  this.removeSticky = () => {
    $(CLASS_HEADER).removeClass(IS_STICKY);
    $(CLASS_MAIN_CONTENT).removeAttr("style");
  };

  /**
   * handleStickMenu
   * @return {void}
   */
  this.init = function () {
    let self = this;
    WINDOW.on("scroll resize", function (e) {
      e.preventDefault();
      if (isExists(CLASS_HEADER)) {
        WINDOW.scrollTop() > 0 ? self.addSticky() : self.removeSticky();
      } else {
        self.removeSticky();
      }
    });

    WINDOW.trigger("scroll");
  };

  return this.init();
};

export default Sticky;
